import React from 'react';
import RoleDropdown, {PlaceholderDropdown, RoleDropdownComponentProps, RoleDropdownQuery} from './RoleDropdown';
import {ForecastQueryRenderer} from '../../../../../ForecastQueryRenderer';

type RoleDropdownRelayProps = {personId?: string; taskId?: string} & RoleDropdownComponentProps;

const RoleDropdownRelayWrapper = ({
	role,
	onSelect,
	isDisabled,
	projectId,
	showMovedToProjectRoleWarning,
	taskId,
	personId,
	showLabel,
	labelFormat,
}: RoleDropdownRelayProps): JSX.Element => {
	return (
		<ForecastQueryRenderer
			showLoader={true}
			customLoader={() => <PlaceholderDropdown showLabel={showLabel} labelFormat={labelFormat} />}
			key="query-render-role-dropdown"
			query={RoleDropdownQuery}
			variables={{projectId: projectId, personId: personId, taskId: taskId}}
			render={relayProps => {
				return (
					<RoleDropdown
						{...relayProps}
						showLabel={showLabel}
						labelFormat={labelFormat}
						role={role}
						showMovedToProjectRoleWarning={showMovedToProjectRoleWarning}
						onSelect={onSelect}
						projectId={projectId}
						taskId={taskId}
						isDisabled={isDisabled}
					/>
				);
			}}
		/>
	);
};

export default RoleDropdownRelayWrapper;
